"use strict";
/**
 * Shared error messages that can be used in both client and server contexts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLOW_QUERY_HINT_TEXT = exports.RESOURCE_LIMIT_ERROR_MESSAGE = void 0;
/**
 * Standard message for resource limit errors (memory, timeout, etc.)
 * Used when queries require too many resources to complete
 */
exports.RESOURCE_LIMIT_ERROR_MESSAGE = [
    "Your query could not be completed.",
    "Please narrow your request by adding more specific filters (e.g., a shorter date range).",
].join(" ");
/**
 * Hint shown for slow-running chart queries after a short delay
 */
exports.SLOW_QUERY_HINT_TEXT = "This query is taking longer than usual. Try reducing the time frame or adding more filters.";
